import React from 'react';
import { SelectStyles } from "./Select.styles.js";
import { SelectMenuOptionsVirtualized } from "./SelectMenuOptionsVirtualized.js";
export var SelectMenuOptions = function SelectMenuOptions(_ref) {
  var cursor = _ref.cursor,
    value = _ref.value,
    filteredOptions = _ref.filteredOptions,
    groups = _ref.groups,
    groupLabels = _ref.groupLabels,
    showGroupDivider = _ref.showGroupDivider,
    groupDivider = _ref.groupDivider,
    virtualized = _ref.virtualized,
    virtualizedContainerHeight = _ref.virtualizedContainerHeight,
    virtualizedContainerWidth = _ref.virtualizedContainerWidth,
    onOptionSelection = _ref.onOptionSelection;
  var handleOptionSelection = function handleOptionSelection(newValue) {
    onOptionSelection(newValue);
  };
  if (virtualized) {
    return /*#__PURE__*/React.createElement(SelectMenuOptionsVirtualized, {
      virtualizedContainerHeight: virtualizedContainerHeight,
      virtualizedContainerWidth: virtualizedContainerWidth,
      options: filteredOptions,
      cursor: cursor,
      value: value,
      showGroupDivider: showGroupDivider,
      groupDivider: groupDivider,
      groupLabels: groupLabels,
      groups: groups,
      onOptionSelection: handleOptionSelection
    });
  }
  if (!groupLabels && !showGroupDivider || groups.length <= 0) {
    return /*#__PURE__*/React.createElement(MenuOptionsList, {
      value: value,
      cursor: cursor,
      options: filteredOptions,
      onOptionSelection: handleOptionSelection
    });
  }
  return /*#__PURE__*/React.createElement(GroupedMenuOptionsList, {
    cursor: cursor,
    value: value,
    groups: groups,
    showGroupDivider: showGroupDivider,
    groupDivider: groupDivider,
    onOptionSelection: handleOptionSelection
  });
};
var MenuOptionsList = function MenuOptionsList(_ref2) {
  var cursor = _ref2.cursor,
    value = _ref2.value,
    options = _ref2.options,
    onOptionSelection = _ref2.onOptionSelection;
  return /*#__PURE__*/React.createElement(React.Fragment, null, options.map(function (option, index) {
    var _option$key, _option$index;
    return /*#__PURE__*/React.createElement(SelectStyles.MenuItemStyled, {
      key: (_option$key = option.key) !== null && _option$key !== void 0 ? _option$key : option.value,
      selected: value === option.value,
      onClick: function onClick() {
        return onOptionSelection(option.value);
      },
      role: "option",
      className: cursor === ((_option$index = option.index) !== null && _option$index !== void 0 ? _option$index : index) ? 'active' : ''
    }, option.label);
  }));
};
var GroupedMenuOptionsList = function GroupedMenuOptionsList(_ref3) {
  var cursor = _ref3.cursor,
    value = _ref3.value,
    groups = _ref3.groups,
    showGroupDivider = _ref3.showGroupDivider,
    groupDivider = _ref3.groupDivider,
    onOptionSelection = _ref3.onOptionSelection;
  var filteredGroups = groups.filter(function (g) {
    return g.items.length > 0;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, filteredGroups.map(function (group, groupIndex) {
    return /*#__PURE__*/React.createElement("span", {
      key: "".concat(group.groupIndex, "_").concat(group.groupLabel),
      "data-testid": "select-group"
    }, groupIndex > 0 && showGroupDivider ? groupDivider || /*#__PURE__*/React.createElement(SelectStyles.GroupDivider, {
      "data-testid": "select-group-divider"
    }) : null, /*#__PURE__*/React.createElement(SelectStyles.ListSubheaderStyled, null, group.groupLabel), /*#__PURE__*/React.createElement(MenuOptionsList, {
      cursor: cursor,
      value: value,
      options: group.items,
      onOptionSelection: onOptionSelection
    }));
  }));
};